import { ClienteAnaliseMercadoSearchClienteOrderBy } from '../cliente-analise-mercado-search-cliente-orderby';

export class ClienteAnaliseMercadoClienteListStorage {
    orderBy: ClienteAnaliseMercadoSearchClienteOrderBy;
}
